var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"elevation-0",attrs:{"color":"transparent"}},[_c('span',{staticClass:"caption"},[_vm._v("v"+_vm._s(_vm.version))]),_c('v-spacer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }